const lists = [
  {
    children: [
      { name: "getTemplateList", url: "aktiva-templates", method: "GET" },
    ],
  },
];

export default lists;
